<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="640px">
      <v-card class="grid">
        <v-card width="100%" class="pl-5 pr-4 mt-4" flat>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex flex-row justify-space-between">
              <span class="title">{{
                $t('message.pages.users.actions.addUser')
              }}</span>
              <v-btn icon @click="handleClose">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <span>
                {{ $t('message.pages.users.userAdd.sentInvite') }}
              </span>
            </v-col>
          </v-row>
        </v-card>

        <!-- steps -->
        <v-card-text class="mt-8 mb-8 pa-0 px-5">
          <v-row no-gutters>
            <v-col cols="12">
              <span class="fieldsTitle">{{ $t('message.name') }}</span>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="addUser.name"
                outlined
                dense
                class="pr-2"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <span class="fieldsTitle">
                {{ $t('message.navDrawer.myProfile.phone') }}
              </span>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="addUser.phone"
                v-mask="['(##) #####-####']"
                placeholder="(11) 12345-6789"
                autocomplete="false"
                outlined
                dense
                class="pr-2"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <span class="fieldsTitle">Email</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="addUser.email"
                placeholder="example@email.com"
                outlined
                dense
                class="pr-2"
                hide-details
              ></v-text-field>
              <v-card flat height="30">
                <span class="red--text footerText align-text d-block my-1">
                  <span v-if="errors.invalidEmail">
                    {{ $t('message.errors.invalidEmail') }}
                  </span>
                </span>
              </v-card>
            </v-col>
            <v-col cols="12">
              <span class="fieldsTitle">{{
                $t('message.pages.users.table.permission')
              }}</span>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="addUser.role_id"
                :items="selectValues"
                item-text="name"
                item-value="id"
                outlined
                dense
                class="pr-2"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" class="mt-2">
              <v-card flat height="30">
                <span class="red--text footerText align-text d-block my-1">
                  <span v-if="errors.unknownError">
                    {{ errors.shownErrMsg }}
                  </span>
                </span>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- actions -->
        <v-card-actions class="px-6 pt-4 pb-6">
          <v-row no-gutters justify="center" align="center">
            <v-spacer />
            <v-btn
              color="primary"
              class="ml-2"
              :loading="loadingFetch"
              :disabled="!fillRequirementsToCreate"
              @click="handleCreateUser"
            >
              {{ $t('message.add') }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import subUsersManagement from '@/services/subUsersManagement'
import i18n from '@/translations/lang'

export default {
  name: 'UserAdd',
  components: {},
  data: () => ({
    open: false,
    selectValues: [],
    addUser: { name: '', phone: '', email: '', role_id: '' },
    loadingFetch: false,
    errors: {
      invalidEmail: false,
      unknownError: false,
      shownErrMsg: '',
      errMsg: i18n.t('message.errors.unexpectedError'),
    },
  }),
  computed: {
    fillRequirementsToCreate() {
      const phoneOnlyNumbers = this.addUser?.phone.replace(/\D/g, '')
      return (
        this.addUser?.name?.length > 2 &&
        phoneOnlyNumbers.length > 10 &&
        this.addUser?.email?.length &&
        this.addUser?.role_id?.length
      )
    },
  },
  mounted() {
    this.$root.$on('openUserAdd', (roles) => {
      Object.assign(this.$data, this.initialState())
      this.selectValues = roles
      this.addUser.role_id = this.selectValues[0].id
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('openUserAdd')
  },
  methods: {
    handleClose() {
      this.open = false
    },
    handleMoreDetails() {
      this.moreDetails = true
    },
    async handleCreateUser() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      this.trimAllFields()
      const email = this.addUser.email
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const valid = re.test(email)
      if (!valid) {
        this.errors.invalidEmail = true
        return
      }
      this.loadingFetch = true
      try {
        let ret = await subUsersManagement.createUser({ ...this.addUser })
        let roleName = ''
        if (ret.data.role_name === 'admin') {
          roleName = this.$i18next.t('message.pages.users.roles.admin')
        } else if (ret.data.role_name === 'viewer') {
          roleName = this.$i18next.t('message.pages.users.roles.viewer')
        }
        let user = {}
        if (roleName) {
          user = { ...ret.data, role_name: roleName }
        } else {
          user = { ...ret.data }
        }
        this.$root.$emit('saveNewUser', user)
        this.loadingFetch = false
        this.open = false
      } catch (e) {
        this.errors.errMsg = e.response.data.errMsg
        this.errors.unknownError = true
        this.loadingFetch = false
        if (e.response.data.errMsg.includes('User already exists')) {
          this.errors.shownErrMsg = i18n.t('message.errors.userAlreadyExists')
        } else {
          this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
        }
        console.error(e)
      }
    },
    initialState() {
      return {
        open: false,
        selectValues: [],
        addUser: { name: '', phone: '', email: '', role_id: '' },
        loadingFetch: false,
        errors: {
          invalidEmail: false,
          unknownError: false,
          shownErrMsg: '',
          errMsg: i18n.t('message.errors.unexpectedError'),
        },
      }
    },
    trimAllFields() {
      Object.keys(this.addUser).forEach(
        (e) => (this.addUser[e] = this.addUser[e].trim())
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  font-size: 18px;
  color: var(--v-brand-darken2);
}
.fieldsTitle {
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: var(--v-neutral-lighten1);
}

.bg-dark,
.theme--dark {
  &::v-deep {
    .title {
      color: #8fb1e3;
    }
  }
}
</style>
